export default __webpack_public_path__ + "static/media/ppf.c6ef0ea4.svg";